import React, {useEffect, useState} from 'react'
import {Link, withRouter} from 'react-router-dom'
import {Page_settings} from '../../config/page_settings'
import strings from '../../lang/strings'
import Menu from '../../config/page_route.jsx'
import {Extra} from '../../config/page_route'
import {inject, observer} from 'mobx-react'

const Header = ({ history, rootStore }) => {
  let [pageIndex, setPageIndex] = useState(-1)
  const routes = [...Extra, ...Menu]
  const [isScrolled, setIsScrolled] = useState(false); 

  const setIndex = path => {
    const route = routes.find(it => it.path == path || it.children?.some(c => c.path == path))
    if (route) {
      if (route.path == path) {
        setPageIndex(route.index)
      } else {
        setPageIndex(route.children?.find(it => it.path == path)?.index)
      }
      return
    }

    if (path.substring(0, 3) == '/bj') {
      setPageIndex(1)
    } else if (path.substring(0, 8) == '/analyst') {
      setPageIndex(2)
    } else if (path.substring(0, 8) == '/my_data') {
      setPageIndex(3)
    } else if (path.substring(0, 5) == '/item') {
      setPageIndex(4)
    } else if (path.substring(0, 3) == '/cs') {
      setPageIndex(5)
    }
  }

  useEffect(() => {
    history.listen(() => {
      setIndex(history.location.pathname)
    })

    setIndex(history.location.pathname)
  })


  useEffect(() => {
    const handleScroll = () => {
      const scrollThreshold = 10;
      setIsScrolled(window.scrollY > scrollThreshold); 
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Page_settings.Consumer>
      {({ toggleMobileSidebar, closeMobileSidebar }) => (
        <div id='header'
          className={`header 
          ${history.location.pathname.substring(0, 10) == '/dashboard' ? 
            (isScrolled ? 'navbar-default' : 'navbar-dashboard')
             : 'navbar-default'
            }`}>
          <div className='navbar-header'>
            <Link to='/dashboard' className='navbar-brand' onClick={closeMobileSidebar}>
              <img className='logo' src={'/assets/image/logo.png'} alt='' />
              <div className='header-title fs-16'>{strings.today_selection}</div>
            </Link>
            {Menu.map((menu, i) => (
              <Link to={menu.path} key={i} className={'header_item ' + ((menu.index === 0 || menu.index === 4 || (menu.index === 3 && (!rootStore.isSignedIn || rootStore.getMe.mb_lv <= 1))) ? 'hide ' : '') + (menu.index === pageIndex ? 'active ' : '')}>
                <div className='header_item fs-16'>{menu.title}</div>
              </Link>
            ))}
            <a type='button' className='drop-menu sm-inherit alarm-animation' href={'/alarm_list'}>
              <img className='ic_alarm' src={'/assets/image/alarm_icon.png'} alt='' />
              {rootStore.getAlarmCount > 0 && (
                <div className="alarm-badge">{`${rootStore.getAlarmCount > 9 ? '9+' : rootStore.getAlarmCount }`}</div>
              )}
            </a>
            <a type='button' className='drop-menu sm-inherit' href={'/mypage/mo_mypage'}>
              <img className='ic_user' src={'/assets/image/ic_user.png'} alt='' />
            </a>
            <button type='button' className='drop-menu sm-inherit' onClick={toggleMobileSidebar}>
              <img className='ic_menu' src={'/assets/image/ic_menu.png'} alt='' />
            </button>
          </div>
        </div>
      )}
    </Page_settings.Consumer>
  )
}

export default withRouter(inject('rootStore')(observer(Header)))
